import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import ServicesMarquee from '../components/ServicesMarquee';
import CertificationsSection from '../components/CertificationsSection';
import EmpowerSection from '../components/EmpowerSection';
import IndustriesSection from '../components/IndustriesSection';
import CaseStudiesSection from '../components/CaseStudiesSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesMarquee />
      <CertificationsSection />
      <EmpowerSection />
      <IndustriesSection />
      <CaseStudiesSection />
      <Footer />
    </div>
  );
};

export default HomePage;
